import React from 'react';
import Content, { HTMLContent } from '../components/Content';
import Logo from '../components/logo/Logo'



export const ResumePageTemplate = ({ title, content, contentComponent, skills }) => {
  const PageContent = contentComponent || Content;
  return <section className="section page resume">
    <div className="container resume-heading">
      <div className="row justify-content-md-center">
        <div className="col-md-3 d-none d-md-block">
          <img src="/img/head-shot.jpg" className="rounded-circle img-thumbnail" />
        </div>
        <div className="col-sm-12 col-md-9 col-xl-6 align-self-center text-center title">
          <hr />
          <Logo size="xl" />
          <h1 className="subheading text-center">
            <small><i>MY EXPERIENCE & SKILLSET</i></small>
          </h1>
          <hr />
        </div>
      </div>

      <div className="row resume-content animate fade-in">
        <div className="col-sm-3 well">
          <h3>
            <i className="fa fa-css3" aria-hidden="true"></i> Skillset
            <small className="pull-right">
              <a href="" className="text-muted">
                <i className="fa fa-search" aria-hidden="true"></i>
              </a>
            </small>

          </h3>
          {skills.map((skill) => {
            return <div key={skill.heading}>
              <strong className="skill-heading text-accent">{skill.heading}</strong>
              <ul className="list-unstyled">
                {skill.skills.map((item) => {
                  return <li key={item}>{item}</li>
                })}
              </ul>
              <hr />
            </div>
          })}
        </div>
        <div className="col-sm-9">
          <PageContent className="content" content={content} />
        </div>
      </div>
    </div>
  </section>;
}

export default ({ data }) => {
  const { markdownRemark: post } = data;
  return <ResumePageTemplate
    contentComponent={HTMLContent}
    title={post.frontmatter.title}
    content={post.html}
    skills={post.frontmatter.skills}
  />;
};

export const pageQuery = graphql`
  query ResumePage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        skills {
          heading
          skills
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/resume-page.js